import React from 'react';

const LongArrowRight = ({ height = 12, width = 12, color = '#494949' }) => (
	<svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width={width} height={height}><title>long arrow right</title>
		<g fill={color}>
		<path d="M11.707,5.293,7,.586,5.586,2l3,3H0V7H8.586l-3,3L7,11.414l4.707-4.707A1,1,0,0,0,11.707,5.293Z" fill={color}/>
		</g>
	</svg>

);

export default LongArrowRight;